import { styled, Table } from '@mui/material';

interface SidePanelPropsTableProps {
  withDividers?: boolean;
  columnSpace?: 'small' | 'medium' | 'large';
}

export const SidePanelPropsTable = styled(Table, {
  shouldForwardProp: (prop) =>
    prop !== 'withDividers' && prop !== 'columnSpace',
})<SidePanelPropsTableProps>(
  ({ withDividers = false, columnSpace = 'small' }) => ({
    '&': {
      width: '100%',
    },
    '& tr td': {
      alignContent: 'start',
      padding: withDividers ? '16px 0 16px 40px' : '5px 0 5px 40px',
    },
    '& tr:first-child td': {
      padding: withDividers ? '0 0 16px 40px' : '0 0 5px 40px',
    },
    '& tr:last-child td': {
      padding: withDividers ? '16px 0 0 40px' : '5px 0 0 40px',
    },
    '& tr td:last-child': {
      paddingRight: '40px',
    },
    '& tr:not(:last-child)': {
      borderBottom: withDividers
        ? '1px dashed var(--mui-palette-divider)'
        : 'none',
    },
    '& .props-col': {
      width:
        columnSpace === 'small'
          ? '170px'
          : columnSpace === 'medium'
            ? '210px'
            : '250px',
      fontWeight: '400',
    },
  })
);
